/* eslint-disable */
import { Input, Select, Button, RadioButton, DatePicker, FileUpload, BrandIconSpinner } from "components";
import React, { useState, useEffect } from "react";
import { JobApply, jobsubmit } from "redux/features/PostJobSlice";
import { useDispatch, useSelector } from "react-redux";
import { Notification } from "components/CustomNotification";
import { t } from "i18next";
import { TemplatesStyle } from "./CreateForm.style";
import { DialogActions, IconButton } from "@mui/material";
import AutoComplete from "components/AutoComplete";
import { ExperienceList } from "assert/OptionList";
import { EmailRegex } from "utils/helper";

import { ReactComponent as BackArrow } from "assert/images/Common/backArrow.svg";
import { ReactComponent as ForwardArrow } from "assert/images/Common/forwardArrow.svg";
import { ReactComponent as Add } from 'assert/images/Profile/add.svg';

export default function CustomTemplate({ jobState, closeModal, handleSuccessClose, setInitialState, setStateChangedValue }) {
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [state, setState] = useState({ skill: "", experience: "" });
  const [newSkill, setNewSkill] = useState('');
  const [initializeSetState, setInitializeSetState] = useState(false);
  const [errMsg, setErrmsg] = useState({ skill: "", experience: "" });
  const [sliceIndex, setSliceIndex] = useState({ firstIndex: 0, lastIndex: 8 });
  const [isLoading, setIsLoading] = useState(false);

  const jobTemplate = jobState?.template;

  const handleChange = (data, name) => {
    setStateChangedValue(JSON.stringify({ ...state, [name]: data?.target?.value || data }));
    setState((prevState) => ({
      ...prevState,
      [name]: data?.target?.value || data,
    }));
  };

  useEffect(() => {
    if (initializeSetState) {
      setInitialState && setInitialState(JSON.stringify(state));
    }
  }, [initializeSetState])

  useEffect(() => {
    jobTemplate?.forEach((value, index) => {
      const key = value.question + index;
      setState((prevState) => ({
        ...prevState,
        [key]: "",
      }));
      value?.required &&
        setErrmsg((prevState) => ({
          ...prevState,
          [key]: "",
        }));
    });
    if (jobTemplate.length > 0) {
      setInitializeSetState(true);
    }
  }, []);

  const handleValidation = () => {
    Object.keys(errMsg).forEach((data) => {
      return (errMsg[data] = state[data] === "" ? "Field Required" : "");
    });
    if (!state.Email0.match(EmailRegex))
      errMsg.Email0 = 'Email is Invalid';
    else errMsg.Email0 = '';
    setErrmsg((prevState) => ({
      ...prevState,
    }));
    // setState((prevState) => ({
    //   ...prevState,
    // }));
  };

  const handleCloseModal = () => {
    closeModal(JSON.stringify(state));
  };

  const Submit = (boln, type) => {
    handleValidation(boln, type);
    const validation = Object.keys(errMsg).every((data) => {
      return errMsg[data] === "";
    });
    if (validation) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("JobPostId", jobState?.jobPostId);
      formData.append("jobPostedBy", jobState?.jobPostedUserInfo?.userId);
      formData.append("userId", getProfile?.userId);
      formData.append("skill", JSON.stringify(state.skill));
      formData.append("experience", state.experience);
      formData.append("userEmail", getProfile?.userEmail);
      const fileSize = [];
      jobTemplate?.forEach((value, index) => {
        if (value.field === "File Upload") {
          const key = value.question + index;
          if (fileSize.length === 0) {
            formData.append("resume", state?.[key]?.[0]);
            fileSize.push(key);
          } else if (fileSize.length === 1) {
            formData.append("coverLetter", state?.[key]?.[0]);
            fileSize.push(key);
          } else if (fileSize.length === 2) {
            formData.append("additionalFile", state?.[key]?.[0]);
            fileSize.push(key);
          }
        }
      });
      fileSize.forEach((li) => delete state[li]);
      formData.append("data", JSON.stringify(state));
      formData.append("customFileNames", JSON.stringify(fileSize));
      dispatch(JobApply(formData))
        .then((res) => {
          handleSuccessClose(jobState?.jobPostId);
          dispatch(jobsubmit(""));
          Notification("success", res?.data?.message);
          setIsLoading(false);
        })
        .catch(() => {
          Notification("warning", "Something went wrong");
          setIsLoading(false);
        });
    }
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const handleQuestion = (data, index) => {
    const key = data.question + index;
    switch (data?.field) {
      case "Free Text":
        return (
          <Input
            label={data.question}
            required={data.required}
            errMsg={errMsg[key]}
            value={state[key]}
            onChange={(e) => handleChange(e, key)}
            multiline
          />
        );
      case "Dropdown":
        const dropdownOptions = [];
        data.options.forEach((li) => dropdownOptions.push({ ...li, disabled: false }));
        return (
          <Select
            label={data.question}
            Options={dropdownOptions}
            required={data.required}
            errMsg={errMsg[key]}
            value={state[key] || ""}
            onChange={(e) => handleChange(e, key)}
          />
        );
      case "Radio Button":
        const radioOptions = [];
        data.options.forEach((li) => radioOptions.push({ ...li, disabled: false }));
        return (
          <RadioButton
            label={data.question}
            required={data.required}
            options={radioOptions}
            errMsg={errMsg[key]}
            value={state[key] || ""}
            onChange={(e) => handleChange(e, key)}
          />
        );
      case "Date Picker":
        return (
          <DatePicker
            label={data.question}
            errMsg={errMsg[key]}
            value={state[key] || ""}
            required={data.required}
            onChange={(e) => handleChange(e, key)}
          />
        );
      case "File Upload":
        return (
          <FileUpload
            label={data.question}
            errMsg={errMsg[key] || ""}
            value={state[key]}
            required={data.required}
            handleFileSRC={(e) => handleChange(e, key)}
          />
        );

      default:
        break;
    }
  };

  const customFields = jobTemplate?.slice(sliceIndex.firstIndex, sliceIndex.lastIndex);
  const isStep2 = jobTemplate?.length > 7 && sliceIndex.firstIndex !== 0;
  const showNextBtn = sliceIndex.firstIndex === 0 && jobTemplate?.length > 7;

  const handleNext = () => {
    let isFilledAllFields = false;
    customFields?.forEach((value, index) => {
      const key = value.question + index;
      if (value?.required) {
        if (!isFilledAllFields && state[key] === "") {
          isFilledAllFields = true;
        }
        errMsg[key] = state[key] === "" ? "Field Required" : "";
        if (state[key] === "Email0") {
          if (!state?.Email0?.match(EmailRegex))
            errMsg.Email0 = 'Email is Invalid';
          else errMsg.Email0 = '';
        }
      }
    });
    setErrmsg((prevState) => ({
      ...prevState,
    }));
    if (!isFilledAllFields) {
      setSliceIndex({ firstIndex: 8, lastIndex: jobTemplate?.length });
    }
  };

  const handleBack = () => {
    setSliceIndex({ firstIndex: 0, lastIndex: 8 });
  };

  const handleAddSkill = () => {
    if (newSkill.trim() !== '') {
      const updatedSkills = [...state.skill, newSkill];
      handleChange(updatedSkills, 'skill');
      setNewSkill('');
    }
  };

  return (
    <TemplatesStyle>
      <BrandIconSpinner loading={isLoading} />
      <div className="custom-template-container">
        {customFields?.map((data, index) => {
          return (
            <span key={index}>
              {handleQuestion(data, isStep2 ? index + 8 : index)}
            </span>
          );
        })}
        {((isStep2) || jobTemplate?.length < 7) && (
          <div>
            <div className="static-field-wrap">
              <div className="static-skills-container">
                <AutoComplete
                  freeSolo
                  multiple
                  required
                  label={"Skills"}
                  value={state.skill}
                  errMsg={errMsg.skill}
                  onChange={(data) => handleChange(data, "skill")}
                  autoCompleteInputValue={newSkill}
                  onInputChange={(_, newInputValue) => setNewSkill(newInputValue)}
                  Options={[]}
                  textPlaceholder={"Press enter or add"}
                />
                <IconButton
                  className="static-skill-icon-btn"
                  aria-label="toggle password visibility"
                  onClick={handleAddSkill}
                  edge="end"
                  size="small"
                >
                  <Add />
                </IconButton>
              </div>
              <AutoComplete
                required
                label={"Total year of experience"}
                value={state.experience}
                errMsg={errMsg.experience}
                onChange={(data) => handleChange(data, "experience")}
                Options={ExperienceList}
              />
            </div>
            <div className="static-field-helper">
              Note: Check the skills and experience, it's play the major role while select the applicant
            </div>
          </div>
        )}
      </div>
      <DialogActions>
        {isStep2 && <Button variant="text" label={"Back"} onClick={handleBack} startIcon={<BackArrow />} />}
        <Button
          variant="text"
          label={showNextBtn ? "Next" : t("Submit")}
          onClick={showNextBtn ? handleNext : Submit}
          endIcon={showNextBtn ? <ForwardArrow /> : <></>}
        />
        <Button variant="text" label="Cancel" customStyles="cancel-btn" onClick={handleCloseModal} />
      </DialogActions>
    </TemplatesStyle>
  );
}